const Coupons = () => import('@/modules/coupons/index.vue');
import checkPermission from '@/modules/coupons/_routes/checkPermission';

export default [
  {
    path: '/cupons',
    name: 'list-coupons',
    component: Coupons,
    props: true,
    beforeEnter: checkPermission,
    meta: {
      isAvaliableInMenu: true,
      navbarTitle: 'Cupons',
      menuData: {
        title: 'Cupons',
        id: 'couponsSidebar',
        section: 'Marketing',
        icon: 'coupon',
      },
    },
  },
  {
    path: '/franquia/cupons',
    name: 'franchise-list-coupons',
    component: Coupons,
    props: true,
    beforeEnter: checkPermission,
    meta: {
      isAvaliableInMenu: false,
      navbarTitle: 'Cupons',
      menuData: {
        title: 'Cupons',
        id: 'couponsSidebar',
        section: 'Marketing',
        icon: 'coupon',
      },
    },
  },
  {
    path: '/cupons/criar',
    name: 'coupons-create',
    component: Coupons,
    props: true,
    beforeEnter: checkPermission,
    meta: {
      navbarTitle: 'Criar cupom',
    },
  },
  {
    path: '/cupons/duplicar',
    name: 'coupons-duplicate',
    component: Coupons,
    props: true,
    beforeEnter: checkPermission,
    meta: {   
      navbarTitle: 'Duplicar cupom',
    },
  },
  {
    path: '/franquia/cupons/criar',
    name: 'franchise-coupons-create',
    component: Coupons,
    props: true,
    beforeEnter: checkPermission,
    meta: {
      navbarTitle: 'Criar cupom',
    },
  },
  {
    path: '/franquia/cupons/duplicar',
    name: 'franchise-coupons-duplicate',
    component: Coupons,
    props: true,
    beforeEnter: checkPermission,
    meta: {
      navbarTitle: 'Duplicar cupom',
    },
  },
];
